export interface IFuelsIndicatorsMarket {
  id: string;
  catalog: {
    id: string;
    name: string;
  };
  referenceDate: string;
  unit: {
    id: string;
    name: string;
  };
  source: string;
  value: number;
  variation: number;
  observation?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ICreateFuelsIndicatorsMarketRequest {
  catalogId: string;
  referenceDate: string;
  unitId: string;
  source: string;
  value: number;
  variation: number;
  observation?: string;
}

export interface IUpdateFuelsIndicatorsMarketRequest extends ICreateFuelsIndicatorsMarketRequest {}

export interface IPanelDashboardMarketData {
  id: string;
  catalogId: string;
  catalogName: string;
  referenceDate: string;
  primaryPanel: string;
  value: string;
  previousValue?: string;
  valueDifference?: string;
  variation: string;
  source: string;
  sparklineData?: number[];
  sparklineDates?: string[];
}

export interface IPanelDashboardEthanolData {
  id: string;
  productLinesId: string;
  productLineName: string;
  referenceDate: string;
  indicator: string;
  ethanolType: string;
  plantCost: string;
  previousPlantCost?: string;
  plantCostDifference?: string;
  dailyVariation: string;
}

export interface IPanelDashboardPetroleumPoleGroup {
  productLineId: string;
  productLineName: string;
  poleGroup: string;
  referenceDate: string;
  pricePbRefinery: string;
  previousPricePbRefinery?: string;
  pricePbRefineryDifference?: string;
  pricePpiRefinery: string;
  previousPricePpiRefinery?: string;
  pricePpiRefineryDifference?: string;
  variacaoPB_PPI: string;
}

export interface IPanelDashboardPetroleumRegion {
  productLineId: string;
  productLineName: string;
  operatorPoleName: string;
  region: string;
  referenceDate: string;
  pricePbRefinery: string;
  previousPricePbRefinery?: string;
  pricePbRefineryDifference?: string;
  pricePpiRefinery: string;
  previousPricePpiRefinery?: string;
  pricePpiRefineryDifference?: string;
  variacaoPB_PPI: string;
}

export interface IPanelDashboardData {
  market: IPanelDashboardMarketData[];
  ethanol: IPanelDashboardEthanolData[];
  petroleumDerivativesPoleGroup: IPanelDashboardPetroleumPoleGroup[];
  petroleumDerivativesRegion?: IPanelDashboardPetroleumRegion[];
}

export interface IDashboardChartMetadata {
  ethanol?: {
    maxDate: string;
    filterOptions: import('../fuelsIndicatorsEthanol/types').IFilterOptions;
  };
  derivatives?: {
    maxDate: string;
    filterOptions: import('../fuelsIndicatorsPetroleumDerivatives/types').IFilterOptions;
  };
  biodiesel?: {
    maxDate: string;
  };
  quotes?: {
    maxDate: string;
  };
}

/** Chaves do endpoint GET /fuels-indicators-market/panel-dashboard/history */
export enum PanelDashboardIndicatorKey {
  USD_BRL = 'USD_BRL',
  BRENT = 'BRENT',
  RBOB = 'RBOB',
  ETHANOL_PAULINIA = 'ETHANOL_PAULINIA',
  PPI_GASOLINA = 'PPI_GASOLINA',
  PPI_DIESEL = 'PPI_DIESEL',
}

export interface IPanelDashboardHistoryQuery {
  indicatorKey: PanelDashboardIndicatorKey;
  catalogId?: string;
  productLinesId?: string;
  ethanolType?: string;
  productLineId?: string;
  baseDate?: string;
  limit?: number;
}

export interface IPanelDashboardHistoryMarketBlock {
  id: string;
  catalogId: string;
  catalogName: string;
  value: string;
  previousValue?: string;
  valueDifference?: string;
  variation: string;
  source: string;
  primaryPanel: string;
  observation?: string;
}

export interface IPanelDashboardHistoryEthanolBlock {
  plantCost: string;
  previousPlantCost?: string;
  plantCostDifference?: string;
  dailyVariation: string;
  indicator?: string;
  ethanolType?: string;
  source?: string;
  observation?: string;
}

export interface IPanelDashboardHistoryPpiBlock {
  pricePbRefinery: string;
  pricePpiRefinery: string;
  variacaoPB_PPI: string;
  previousPricePbRefinery?: string;
  previousPricePpiRefinery?: string;
  pricePbRefineryDifference?: string;
  pricePpiRefineryDifference?: string;
  percentageLag?: string;
  poleGroup?: string;
  source?: string;
  observation?: string;
}

export interface IPanelDashboardHistoryRecord {
  referenceDate: string;
  market?: IPanelDashboardHistoryMarketBlock | null;
  ethanol?: IPanelDashboardHistoryEthanolBlock | null;
  ppi?: IPanelDashboardHistoryPpiBlock | null;
}

export interface IPanelDashboardHistoryResponse {
  indicatorKey: PanelDashboardIndicatorKey;
  records: IPanelDashboardHistoryRecord[];
}
